import { Guid } from '@ef-carbon/primitive';
import { isGroup } from '../isGroup';
function groupsGet(selection, groups) {
    if (!groups) {
        throw new TypeError(`The process options group was 'undefined' when trying to process the '${ selection }' group`);
    }
    const group = groups.get(selection);
    if (!group) {
        const keys = Array.from(groups.keys()).map(k => `'${ k }'`).join(', ');
        throw new RangeError(`Failed to find the '${ selection }' group in the provided groups (${ keys })`);
    }
    return group;
}
export async function linkProcessRandom(link, context, {groups}) {
    const {
        redirect: redirection,
        ids: selection
    } = link;
    const redirect = redirection ? new Guid(redirection) : undefined;
    const ids = !isGroup(selection) ? selection : groupsGet(selection, groups);
    const {length} = ids;
    if (length <= 0) {
        throw new RangeError('Random link has no IDs');
    }
    const max = length - 1;
    const index = Math.round(Math.random() * max);
    const id = ids[index];
    return {
        id: new Guid(id),
        redirect,
        context
    };
}
export {
    linkProcessRandom as process,
    linkProcessRandom as random
};
export default linkProcessRandom;    //# sourceMappingURL=random.js.map
